module.exports = __webpack_public_path__ + "img/cover-vote.a4530bf2.jpg";